'use client';

import React from 'react';
import NavBar from '@/components/header/NavBar';
import Footer from '@/components/Footer/Footer';
import { Link } from '@/i18n/routing';
const TermsAndConditions: React.FC = () => {
  return (
    <>
      <NavBar />

      {/* Hero */}
      <div
        className="bg-cover bg-center bg-no-repeat h-96 lg:h-[500px] relative"
        style={{ backgroundImage: `url('/hero/terms.avif')` }}
      >
        <div className="absolute inset-0 bg-secondary/55 h-96 lg:h-[500px]" />
        <h1 className="absolute inset-0 flex items-center pt-20 lg:pt-40 justify-center text-white text-5xl lg:text-9xl font-extrabold text-center px-4">
          Terms &amp; Conditions
        </h1>
      </div>

      {/* Content */}
      <section className="max-w-4xl mx-auto px-4 lg:px-0 py-16 lg:py-24 text-gray-700 leading-relaxed">
        <p className="mb-6 text-sm text-gray-500">Last updated: September 23, 2026</p>

        <p className="mb-6">
          These Terms and Conditions (&quot;Terms&quot;) govern your access to and use of the
          Evinov (&quot;Evinov&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) website and
          services. By accessing our website or engaging our services, you agree to be bound by
          these Terms. If you do not agree, please do not use our website or services.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">1. About Us</h2>
        <p className="mb-6">
          Evinov is a web development company providing website design, development, and related
          digital services to clients. Any reference to &quot;services&quot; in these Terms includes
          all deliverables, consultations, and support provided by Evinov.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">2. Use of Our Website</h2>
        <p className="mb-4">By using our website, you agree that you will not:</p>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>Use the site for any unlawful purpose or in violation of these Terms</li>
          <li>Attempt to gain unauthorized access to our systems or networks</li>
          <li>Introduce viruses, malware, or other harmful material</li>
          <li>Copy, reproduce, or distribute our content without prior written consent</li>
          <li>Interfere with the proper functioning of the website</li>
        </ul>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">3. Services &amp; Proposals</h2>
        <p className="mb-6">
          Any project undertaken by Evinov will be governed by a separate written proposal, quote,
          or service agreement outlining the scope of work, timelines, deliverables, and fees. These
          Terms apply in addition to, and do not replace, any such agreement. In the event of a
          conflict, the specific project agreement will take precedence.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">4. Fees &amp; Payment</h2>
        <p className="mb-6">
          Fees for our services will be outlined in the relevant proposal or agreement. Unless
          otherwise stated, invoices are due within the timeframe specified at the time of
          engagement. Late payments may result in suspension of services or additional charges as
          permitted by law.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">5. Intellectual Property</h2>
        <p className="mb-6">
          Unless otherwise agreed in writing, all content on this website — including text, graphics,
          logos, and design — is the property of Evinov and protected by applicable intellectual
          property laws. Upon full payment for a completed project, ownership of the final
          deliverables will transfer to the client as specified in the project agreement, excluding
          any third-party tools, frameworks, or licensed assets used in development.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">6. Client Responsibilities</h2>
        <p className="mb-6">
          Clients are responsible for providing accurate information, timely feedback, and any
          necessary content, assets, or access credentials required to complete a project. Delays
          caused by incomplete or late client input may affect project timelines.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">7. Limitation of Liability</h2>
        <p className="mb-6">
          To the fullest extent permitted by law, Evinov shall not be liable for any indirect,
          incidental, special, or consequential damages arising from your use of our website or
          services. Our total liability for any claim arising from our services shall not exceed the
          amount paid by the client for the specific service in question.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">8. Third-Party Links &amp; Services</h2>
        <p className="mb-6">
          Our website and deliverables may include links to or integrations with third-party
          services. We are not responsible for the content, accuracy, or practices of any
          third-party websites or services.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">9. Termination</h2>
        <p className="mb-6">
          We reserve the right to suspend or terminate access to our website or services at our
          discretion, including in cases of misuse, non-payment, or breach of these Terms.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">10. Governing Law</h2>
        <p className="mb-6">
          These Terms shall be governed by and construed in accordance with the laws of the
          jurisdiction in which Evinov operates, without regard to its conflict of law provisions.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">11. Changes to These Terms</h2>
        <p className="mb-6">
          We may update these Terms from time to time. Any changes will be posted on this page with
          a revised &quot;Last updated&quot; date. Continued use of our website or services after
          changes are posted constitutes acceptance of the updated Terms.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">12. Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us through our{' '}
           <Link href="/contact-us" className="text-secondary underline">Contact page</Link>.
        </p>
      </section>

      <Footer />
    </>
  );
};

export default TermsAndConditions;